import { render, staticRenderFns } from "./ProductTagModal.vue?vue&type=template&id=482d1c68&"
import script from "./ProductTagModal.vue?vue&type=script&lang=js&"
export * from "./ProductTagModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pbit/xtkf-a1/s365/env_cloud_web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('482d1c68')) {
      api.createRecord('482d1c68', component.options)
    } else {
      api.reload('482d1c68', component.options)
    }
    module.hot.accept("./ProductTagModal.vue?vue&type=template&id=482d1c68&", function () {
      api.rerender('482d1c68', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/gift/orderMgt/modules/ProductTagModal.vue"
export default component.exports